(function () {    
    angular.module('bizPartEngage').directive('bizDeactivateGoal', bizDeactivateGoalDirective);
    
    bizDeactivateGoalDirective.$inject = ["bizCore"];

    function bizDeactivateGoalDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                goal: '=',
                cancel: '&?',
                postInactivateAction: '&?',
                deleteMode: '=?'
            },
            templateUrl: bizCoreProvider.getView('bizMyGoalsDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/deactivateGoal.html'),
            bindToController: true,
            controller: bizDeactivateGoalController,
            controllerAs: 'vm'
        };

        bizDeactivateGoalController.$inject = ["modules.goals.service"];

        return directive;

        function bizDeactivateGoalController(engagementGoalsService) {
            var vm = this;

            vm.Init = Init;
            vm.Cancel = Cancel;
            vm.Inactivate = Inactivate;
            vm.SelectGoal = SelectGoal;            
            vm.FilterGoals = FilterGoals;

            function Cancel() {
                if (vm.cancel) {
                    vm.cancel();
                }
            }

            function SelectGoal(goal) {
                if (goal.selected) {
                    goal.selected = false;
                } else {
                    for (var i = 0; i < vm.MoveToGoalList.length; i++) {
                        if (vm.MoveToGoalList[i].selected) {
                            vm.MoveToGoalList[i].selected = false;
                        }
                    }
                    goal.selected = true;
                }
            }            

            function Inactivate() {

                var goalIdToMoveTo = -1;
                for (var i = 0; i < vm.MoveToGoalList.length; i++) {
                    if (vm.MoveToGoalList[i].selected) {
                        goalIdToMoveTo = vm.MoveToGoalList[i].Id;
                    }
                }

                engagementGoalsService.InactivateGoal(vm.goal.Id, goalIdToMoveTo, vm.deleteMode).then(InactivateGoalCallback);

                function InactivateGoalCallback(response) {
                    if (vm.postInactivateAction) {
                        vm.postInactivateAction();
                    }
                }
            }

            function FilterGoals() {
                return function (goal) {
                    return goal.Id !== vm.goal.Id && goal.ParentGoalId > 0;
                }
            }

            function Init() {
                engagementGoalsService.GetGoals().then(GetGoalsCallback);

                function GetGoalsCallback(response) {
                    vm.MoveToGoalList = BizPartCoreHelpers.getResponseValue(response, []);
                    if (vm.goal.ParentGoalId <= 0) {
                        vm.ChildGoals = vm.MoveToGoalList.GetItemsByValue('ParentGoalId', vm.goal.Id);
                    }
                }
            }

            vm.$onInit = vm.Init;
        }
    }

}());